import styled from "@emotion/styled";
import { MenuItem, menuItemClasses } from "@kaltura/ds-react-components";

export const AddToCalendarMenuItem = styled(
    MenuItem,
    {
        shouldForwardProp: (prop) => prop !== "color",
    }
)<{ color?: "default" | "white" }>(({ theme, color }) => ({
    ...(color === "white" && { color: theme.palette.common.white }),
    "&:hover, &:focus, &:active, &:visited": {
        ...(color === "white" && { color: theme.palette.common.white }),
    },
    [`& .${menuItemClasses.title}`]: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
}));
